// Auto-generated index file

import NavigationReducer from "./NavigationReducer";

export default NavigationReducer;

export { updateNavigationObject } from "./NavigationActions";
export {
  NAME,
  UPDATE_NAVIGATION_OBJECT,
  CAMPAIGN_KEYWORDS,
  ROUTE_TYPES,
  TEACHER_PROFILE_NAV_CONTEXT,
} from "./NavigationConstants";
export { initialState, REDUCER_HANDLERS } from "./NavigationReducer";
export {
  getCurrentTab,
  handleQueryParameters,
  updateQueryParameters,
  navigate,
  handleParentNotification,
  goToLoginHomeScreen,
  goToHomeroomAttendanceRoute,
  goToAttendanceRoute,
  goToGoalsRoute,
  goToStudentProfileIBISRegistration,
  goToSyncModule,
  goToSyncDashboard,
  goToNewAttendanceExcusalRoute,
  getUnitPlanIdFromPreset,
  goToInviteSignUp,
  goToParentInviteSignUp,
  goToUnitPlanDetail,
  goToResourceDetails,
  switchBetweenModules,
  navigateToProgressReportRoute,
  openComment,
  doTransitionBasedOnRoles,
  goToAbsoluteAdminChildNode,
  goToClassRoster,
  goToAdminRoute,
  goToAdminChildRoute,
  goToAdminSettingsRoute,
  goToAccountAcademicPortalRoute,
  goToAdminHomeRoute,
  goToToolRoute,
  goToPlatformAccessManagerRoute,
  navigateToPlatformAccessManager,
  navigateToMyFamilyProfile,
  navigateToToolsPortal,
  goToToolRouteV2,
  navigateToToolsPortalV2,
  goToPlatformHomeRoute,
  goToPlatformHomeChildRoute,
  goToAssessmentInSchoolLibrary,
  goToMessagingLinkRoute,
  goToStudentProfileRoute,
  goToFamilyProfileRoute,
  goToLearningCourseChildRoute,
  goToPlatformHomeFeatureRoute,
  goToPlatformHomeProjectFeatureRoute,
  goToProjectFeatureRouteByProjectGroupType,
  goToRoute,
  goToBack,
  goToIndex,
  goToLibraryEntity,
  goToSnpHomeChildRoute,
  goToPageNotFound,
  goToUserBlockedPage,
  goToMigrationInProgress,
  goToRootPath,
  navigateToOrgWorkspaceLoginPage,
  getCurriculumTypeFromProjectGroupId,
  setCurriculumProgramInRedux,
  navigateToWorkflow,
  navigateToMBSponteFeeWidget,
  redirectToCombinedCurriculumRoute,
  navigateToTeacherProfile,
} from "./NavigationThunks";

export {
  campaignParams,
  getPathFromFullPath,
  getQueryUpdatedQueryString,
  getRouteAfterParam,
  handlePipsMobileRedirection,
  handleSchoolLoginMobileRedirection,
  handleSamlMobileRedirection,
  handleBlackbaudMobileRedirection,
  handleVeracrossMobileRedirection,
  handleAppRedirection,
  handleStudentGoalsAppRedirection,
  handlePostMobileRedirection,
  getIsSaaRevampEnabled,
  getIsCombineCurriculumHomePageEnabled,
  openToddleApp,
  handleClasslinkMobileRedirection,
} from "./NavigationUtils";
